import { GoogleAnalytics } from './GoogleAnalytics';

export function VendorScripts() {
  return (
    <>
      <GoogleAnalytics />
    </>
  );
}
